import { createSelector } from 'reselect';
import { getEvaluationResults } from 'src/modules/evaluation/selectors/getEvaluationResults';
import { ProjectListItemMetrics } from 'src/modules/project-list/types/ProjectListItem';

export const getProjectListItemMetrics = createSelector([
  getEvaluationResults,
], (evaluation): ProjectListItemMetrics => ({
  roiExclCO2: evaluation.charts.ROI?.find((it) => it.year.equals(10))?.value.exclCO2 ?? null,
  roiExclCO2_5: evaluation.charts.ROI?.find((it) => it.year.equals(5))?.value.exclCO2 ?? null,
  roiExclCO2_2: evaluation.charts.ROI?.find((it) => it.year.equals(2))?.value.exclCO2 ?? null,
  bepExclCO2: evaluation.charts.BEP?.years.exclCO2 ?? null,
}));
